// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import UploaderForm from '../components/UploaderForm';
import { saveUploader } from '../../../../actions/uploaderActions';
import { getAllWorkflows } from '../../../../actions/workflowActions';
import { getKeyProviders } from '../../../../actions/keyProviderActions';
import { getPlatforms } from '../../../../actions/platformActions';
import { getUserProfileGroups } from '../../../../actions/userProfileGroupActions';
import { getCompanyIdsForAnyPermission } from '../../../auth/authUtils';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';
import { fetchCompanies } from '../../../../reducers/companyReducer';
import { useAppDispatch, useAppSelector } from '../../../../hooks';

function AddUploader({
  done,
  id,
  cancel,
  workflows,
  getAllWorkflows,
  keyProviders,
  getKeyProviders,
  platforms,
  getPlatforms,
  keyProviderId,
  keyWorkflowId,
  platformId,
}) {
  const dispatch = useAppDispatch();
  const companies = useAppSelector((state) => state.companies);
  const currentUser = useAppSelector((state) => state.auth);

  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    getValues,
    clearErrors,
    setValue,
    watch,
  } = useForm();

  const [uploader] = useState({ keyWorkflowId, keyProviderId, platformId });
  const [allowedPublishers, setAllowedPublishers] = useState();
  const [groups, setGroups] = useState();

  const addingSpecific = keyProviderId || keyWorkflowId || platformId;

  //companies
  useEffect(() => {
    if (!companies) {
      dispatch(fetchCompanies());
    }
  }, [companies, dispatch]);

  useEffect(() => {
    let pubs = getCompanyIdsForAnyPermission(currentUser);
    setAllowedPublishers(pubs);
  }, [companies, currentUser]);

  useEffect(() => {
    if (!workflows && !addingSpecific) {
      getAllWorkflows();
    }
  }, [workflows, getAllWorkflows, addingSpecific]);

  useEffect(() => {
    if (!keyProviders && !addingSpecific) {
      getKeyProviders();
    }
  }, [keyProviders, getKeyProviders, addingSpecific]);

  useEffect(() => {
    if (!platforms && !addingSpecific) {
      getPlatforms();
    }
  }, [platforms, getPlatforms, addingSpecific]);

  useEffect(() => {
    // get the groups
    if (!groups) {
      getUserProfileGroups()
        .then((d) => {
          setGroups(d.data);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [groups]);

  const onSubmit = (data) => {
    data = {
      ...data,
      ...{
        platformId: data.platformId || platformId,
        keyProviderId: data.keyProviderId || keyProviderId,
        keyWorkflowId: data.keyWorkflowId || keyWorkflowId,
      },
    };
    saveUploader(data)
      .then((savedUploader) => {
        toast.success(t('Uploader saved'));
        done(savedUploader);
      })
      .catch(() => {
        toast.error(t('Failed to save uploader'));
      });
  };

  return (
    <SlideoutLayout
      title={id ? t('Edit uploader') : t('Add uploader')}
      cancel={cancel}
      done={done}
      bar={
        <Button
          type="submit"
          text={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          testId="save-uploader-button"
        />
      }
    >
      <UploaderForm
        uploader={uploader}
        register={register}
        errors={errors}
        control={control}
        getValues={getValues}
        setValue={setValue}
        watch={watch}
        workflows={workflows}
        clearErrors={clearErrors}
        keyProviders={keyProviders}
        platforms={platforms}
        addingSpecific={addingSpecific}
        groups={groups}
        companies={companies}
        allowedPublishers={allowedPublishers}
      />
    </SlideoutLayout>
  );
}



function mapStateToProps(state, ownProps) {
  return {
    workflows: state.workflows,
    keyProviders: state.keyProviders,
    platforms: state.platforms,
  };
}

const mapDispatchToProps = {
  getAllWorkflows,
  getKeyProviders,
  getPlatforms,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUploader);
